import type { SchemaBuilderFieldEditableConfig } from "./schema-builder-field-editor.type";

export const SCHEMA_BUILDER_FIELD_EDIATBLE: SchemaBuilderFieldEditableConfig = {
  // Severity section fields = not editable
  defects: false,
  inspectedComponent: false,
  materials: false,
  severities: false,

  // Other fields = editable
  label: true,
  number: true,
  text: true,
  textArea: true,
  checkbox: true,
  select: true,
  expression: true,
  assetUnlockToggler: true,
};
